import { NoticeSettings, NoticeTypes } from './messages/Notice/NoticeSettings';
import { IOSSettings, IOSTypes } from './messages/IOS/IOSSettings';
import { CustomSettings, CustomTypes } from './messages/Custom/CustomSettings';
import { PrivacyManagerCCPASettings, PrivacyManagerCCPATypes } from './messages/PrivacyManagerCCPA/PrivacyManagerCCPASettings';
import { PrivacyManagerUSSettings, PrivacyManagerUSTypes } from './messages/PrivacyManagerUS/PrivacyManagerUSSettings';
import { ButtonSettings, ButtonTypes } from './Components/Button/ButtonSettings';
import { ColumnSettings, ColumnTypes } from './Components/Column/ColumnSettings';
import { RowSettings, RowTypes } from './Components/Row/RowSettings';
import { ImageSettings, ImageTypes } from './Components/Image/ImageSettings';
import { TextSettings, TextTypes } from './Components/Text/TextSettings';
import { StacksSettings, StacksTypes } from './Components/Stacks/StacksSettings';
import { CategoriesSettings, CategoriesTypes } from './Components/Categories/CategoriesSettings';
import { PrivacyManagerTCFv2Settings, PrivacyManagerTCFv2Types } from './Components/PrivacyManagerTCFv2/PrivacyManagerTCFv2Settings';
import { PMTCFv2InlineSettings, PMTCFv2InlineTypes } from './Components/PMTCFv2Inline/PMTCFv2InlineSettings';
import { PMCCPASettings, PMCCPATypes } from './Components/PMCCPA/PMCCPASettings';
import { PMUSSettings, PMUSTypes } from './Components/PMUS/PMUSSettings';
import { PMUSNeutralSettings, PMUSNeutralTypes } from './Components/PMUSNeutral/PMUSNeutralSettings';
import { PrivacyManagerOTTSettings, PrivacyManagerOTTTypes } from './messages/PrivacyManagerOTT/PrivacyManagerOTTSettings';
import { PMButtonSettings, PMButtonTypes } from './Components/PMButton/PMButtonSettings';
import { IOSButtonSettings, IOSButtonTypes } from './Components/IOSButton/IOSButtonSettings';
import { CCPAPrivacyManagerOTTSettings, CCPAPrivacyManagerOTTTypes } from './messages/CCPAPrivacyManagerOTT/CCPAPrivacyManagerOTTSettings';
import { PreferencesSettings, PreferencesTypes } from './messages/Preferences/PreferencesSettings';
import { SarSettings, SarTypes } from './messages/SAR/SarSettings';
import { InputSettings, InputTypes } from './Components/Input/InputSettings';
import { SubmitButtonSettings, SubmitButtonTypes } from './Components/SubmitButton/SubmitButtonSettings';
import { ErrorBlockTypes, ErrorBlockSettings } from './Components/ErrorBlock/ErrorBlockSettings';
import { TextAreaSettings, TextAreaTypes } from './Components/TextArea/TextAreaSettings';
import { RadioSettings, RadioTypes } from './Components/Radio/RadioSettings';
import { DsarRetrievalSettings, DsarRetrievalTypes } from './messages/DsarRetrieval/DsarRetrievalSettings';
import { CustomButtonSettings, CustomButtonTypes } from './Components/CustomButton/CustomButtonSettings';
import { PrivacyManagerSettings, PrivacyManagerTypes } from './messages/PrivacyManager/PrivacyManagerSettings';
import { DropdownSettings, DropdownTypes } from './Components/Dropdown/DropdownSettings';
import { DatePickerTypes, DatePickerSettings } from './Components/DatePicker/DatePickerSettings';
import { CheckboxGroupTypes, CheckboxGroupSettings } from './Components/CheckboxGroup/CheckboxGroupSettings';
import noticeStarter from './messages/Notice/noticeStarter';
import IOSStarter from './messages/IOS/IOSStarter';
import CustomStarter from './messages/Custom/CustomStarter';
import privacyManagerCCPAStarter from './messages/PrivacyManagerCCPA/PrivacyManagerCCPAStarter';
import privacyManagerUSStarter from './messages/PrivacyManagerUS/PrivacyManagerUSStarter';
import sarStarter from './messages/SAR/sarStarter';
import dsarRetrievalStarter from './messages/DsarRetrieval/dsarRetrievalStarter';
import privacyManagerStarter from './messages/PrivacyManager/privacyManagerStarter';
import privacyManagerOTTStarter from './messages/PrivacyManagerOTT/privacyManagerOTTStarter';
import ccpaPrivacyManagerOTTStarter from './messages/CCPAPrivacyManagerOTT/ccpaPrivacyManagerOTTStarter';
import nativeOttStarter from './messages/NativeOtt/nativeOttStarter';
import preferencesStarter from './messages/Preferences/preferencesStarter';
import sarRequirements from './messages/SAR/sarRequiredComponents';
import dsarRetrievalRequirements from './messages/DsarRetrieval/dsarRetrievalRequiredComponents';
import { OTTCardSettings, OTTCardsTypes } from './Components/OTTCards/OTTCardsSettings';
import { OTTCCPACardsSettings, OTTCCPACardsTypes } from './Components/OTTCards/OTTCCPACardsSettings';
import { OTTSwitchCardSettings, OTTSwitchCardTypes } from './Components/OTTSwitchCard/OTTSwitchCardSettings';
import { OTTNavButtonSettings, OTTNavButtonTypes } from './Components/OTTNavButton/OTTNavButtonSettings';
import { nativePmViews, privacyManagerOTTViews } from './constants';
import { NativeOttSettings, NativeOttTypes } from './messages/NativeOtt/NativeOttSettings';
import { NativeViewSettings, NativeViewTypes } from './Components/NativeOtt/views/NativeViewSettings';
import { ButtonSettings as NativeButtonSettings, ButtonTypes as NativeOttButtonTypes } from './Components/NativeOtt/common/Button/ButtonSettings';
import { CookieTableSettings, CookieTableTypes } from './Components/NativeOtt/common/CookieTable/CookieTableSettings';
import { LogoSettings as NativeImageSettings, LogoTypes as NativeImageTypes } from './Components/NativeOtt/common/Logo/LogoSetting';
import { LongButtonSettings, LongButtonTypes } from './Components/NativeOtt/common/LongButton/LongButtonSettings';
import { SliderSettings, SliderTypes } from './Components/NativeOtt/common/Slider/SliderSettings';
import { TextSettings as NativeTextSettings, TextTypes as NativeTextTypes } from './Components/NativeOtt/common/Text/TextSettings';
import { PMTCFv2InlineNeutralSettings, PMTCFv2InlineNeutralTypes } from './Components/PMTCFv2InlineNeutral/PMTCFv2InlineNeutralSettings';
import { PreferencesCenterSettings, preferencesCenterTypes } from './Components/Preferences/PreferencesCenter/PreferencesCenterSettings';
import { PreferencesButtonSettings, preferencesButtonTypes } from './Components/Preferences/PreferencesButton/PreferencesButtonSettings';
export const Settings = {
  Notice: NoticeSettings,
  PrivacyManager: PrivacyManagerSettings,
  IOS: IOSSettings,
  Custom: CustomSettings,
  PrivacyManagerTCFv2: PrivacyManagerTCFv2Settings,
  PrivacyManagerCCPA: PrivacyManagerCCPASettings,
  PrivacyManagerUS: PrivacyManagerUSSettings,
  PrivacyManagerOTT: PrivacyManagerOTTSettings,
  PrivacyManagerOTTVendorsView: PrivacyManagerOTTSettings,
  PrivacyManagerOTTCategoriesView: PrivacyManagerOTTSettings,
  PrivacyManagerOTTCardDetailsView: PrivacyManagerOTTSettings,
  PMCCPA: PMCCPASettings,
  PMUS: PMUSSettings,
  PMUSNeutral: PMUSNeutralSettings,
  Preferences: PreferencesSettings,
  CCPAPrivacyManagerOTT: CCPAPrivacyManagerOTTSettings,
  CCPAPrivacyManagerOTTVendorsView: CCPAPrivacyManagerOTTSettings,
  CCPAPrivacyManagerOTTCategoriesView: CCPAPrivacyManagerOTTSettings,
  CCPAPrivacyManagerOTTPreferencesView: CCPAPrivacyManagerOTTSettings,
  CCPAPrivacyManagerOTTCustomView: CCPAPrivacyManagerOTTSettings,
  PMTCFv2Inline: PMTCFv2InlineSettings,
  PMTCFv2InlineNeutral: PMTCFv2InlineNeutralSettings,
  Sar: SarSettings,
  Success: SarSettings,
  Error: SarSettings,
  DsarRetrieval: DsarRetrievalSettings,
  OneTimeCodeView: DsarRetrievalSettings,
  CodeSuccessView: DsarRetrievalSettings,
  RequestPendingView: DsarRetrievalSettings,
  Button: ButtonSettings,
  PMButton: PMButtonSettings,
  IOSButton: IOSButtonSettings,
  CustomButton: CustomButtonSettings,
  Column: ColumnSettings,
  Image: ImageSettings,
  Row: RowSettings,
  Text: TextSettings,
  Stacks: StacksSettings,
  Categories: CategoriesSettings,
  Input: InputSettings,
  SubmitButton: SubmitButtonSettings,
  ErrorBlock: ErrorBlockSettings,
  TextArea: TextAreaSettings,
  Radio: RadioSettings,
  Dropdown: DropdownSettings,
  DatePicker: DatePickerSettings,
  CheckboxGroup: CheckboxGroupSettings,
  OTTCards: OTTCardSettings,
  OTTSwitchCard: OTTSwitchCardSettings,
  OTTNavButton: OTTNavButtonSettings,
  OTTCCPACards: OTTCCPACardsSettings,
  PreferencesCenter: PreferencesCenterSettings,
  PreferencesButton: PreferencesButtonSettings
};
export const Types = {
  Notice: NoticeTypes,
  IOS: IOSTypes,
  Custom: CustomTypes,
  PrivacyManager: PrivacyManagerTypes,
  PrivacyManagerCCPA: PrivacyManagerCCPATypes,
  PrivacyManagerUS: PrivacyManagerUSTypes,
  PrivacyManagerTCFv2: PrivacyManagerTCFv2Types,
  PrivacyManagerOTT: PrivacyManagerOTTTypes,
  PrivacyManagerOTTVendorsView: PrivacyManagerOTTTypes,
  PrivacyManagerOTTCategoriesView: PrivacyManagerOTTTypes,
  PrivacyManagerOTTCardDetailsView: PrivacyManagerOTTTypes,
  PrivacyManagerOTTPrivacyPolicyView: PrivacyManagerOTTTypes,
  PrivacyManagerOTTCustomView: PrivacyManagerOTTTypes,
  PMCCPA: PMCCPATypes,
  PMUS: PMUSTypes,
  PMUSNeutral: PMUSNeutralTypes,
  CCPAPrivacyManagerOTT: CCPAPrivacyManagerOTTTypes,
  CCPAPrivacyManagerOTTVendorsView: CCPAPrivacyManagerOTTTypes,
  CCPAPrivacyManagerOTTCategoriesView: CCPAPrivacyManagerOTTTypes,
  CCPAPrivacyManagerOTTPreferencesView: CCPAPrivacyManagerOTTTypes,
  CCPAPrivacyManagerOTTPrivacyPolicyView: CCPAPrivacyManagerOTTTypes,
  CCPAPrivacyManagerOTTCardDetailsView: CCPAPrivacyManagerOTTTypes,
  CCPAPrivacyManagerOTTCustomView: CCPAPrivacyManagerOTTTypes,
  PMTCFv2Inline: PMTCFv2InlineTypes,
  PMTCFv2InlineNeutral: PMTCFv2InlineNeutralTypes,
  Sar: SarTypes,
  Success: SarTypes,
  Error: SarTypes,
  DsarRetrieval: DsarRetrievalTypes,
  OneTimeCodeView: DsarRetrievalTypes,
  CodeSuccessView: DsarRetrievalTypes,
  RequestPendingView: DsarRetrievalTypes,
  Button: ButtonTypes,
  PMButton: PMButtonTypes,
  IOSButton: IOSButtonTypes,
  CustomButton: CustomButtonTypes,
  Column: ColumnTypes,
  Image: ImageTypes,
  Row: RowTypes,
  Text: TextTypes,
  Stacks: StacksTypes,
  Categories: CategoriesTypes,
  Input: InputTypes,
  SubmitButton: SubmitButtonTypes,
  ErrorBlock: ErrorBlockTypes,
  TextArea: TextAreaTypes,
  Radio: RadioTypes,
  Dropdown: DropdownTypes,
  DatePicker: DatePickerTypes,
  CheckboxGroup: CheckboxGroupTypes,
  OTTCards: OTTCardsTypes,
  OTTNavButton: OTTNavButtonTypes,
  OTTSwitchCard: OTTSwitchCardTypes,
  OTTCCPACards: OTTCCPACardsTypes,
  Preferences: PreferencesTypes,
  PreferencesCenter: preferencesCenterTypes,
  PreferencesButton: preferencesButtonTypes
};
export const starters = {
  notice: noticeStarter,
  ios: IOSStarter,
  custom: CustomStarter,
  ccpa_pm: privacyManagerCCPAStarter,
  us_pm: privacyManagerUSStarter,
  sar: sarStarter,
  dsarRetrieval: dsarRetrievalStarter,
  "notice-tcf-v2": noticeStarter,
  "privacy-manager": privacyManagerStarter,
  'privacy-manager-ott': privacyManagerOTTStarter,
  notice_non_iab: noticeStarter,
  privacy_manager_non_iab: privacyManagerStarter,
  ccpa_ott: ccpaPrivacyManagerOTTStarter,
  preferences: preferencesStarter
};
export const requiredComponents = {
  sar: sarRequirements,
  dsarRetrieval: dsarRetrievalRequirements
};
export const constants = {
  pmOTTViews: privacyManagerOTTViews
};
export const nativeOtt = {
  starter: nativeOttStarter,
  settings: {
    NativeOttSettings,
    NativeViewSettings,
    NativeButtonSettings,
    CookieTableSettings,
    NativeImageSettings,
    LongButtonSettings,
    SliderSettings,
    NativeTextSettings
  },
  types: {
    NativeOtt: NativeOttTypes,
    NativeView: NativeViewTypes,
    NativeButton: NativeOttButtonTypes,
    CookieTable: CookieTableTypes,
    NativeImage: NativeImageTypes,
    LongButton: LongButtonTypes,
    Slider: SliderTypes,
    NativeText: NativeTextTypes
  },
  constants: nativePmViews,
  settingKeys: {
    options: ['showPrivacyPolicyBtn', 'supportedLanguages', 'defaultLanguage', 'vendorList', 'selectedLanguage', 'languages', 'startFocus'],
    style: ['backgroundColor', 'alphabetizeVendors', 'font', 'url', 'width', 'text', 'consentText', 'legitInterestText', 'onFocusBackgroundColor', 'onUnfocusBackgroundColor', 'onFocusTextColor', 'onUnfocusTextColor', 'magnifyingGlassColor', 'magnifyingGlassBackgroundColor', 'activeFont', 'activeBackgroundColor', 'onText', 'offText', 'customCategoryText', 'customVendorText', 'onOffFont', 'chevronColor', 'leftText', 'rightText']
  }
};